"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const react_1 = __importDefault(require("react"));
function getHistoryIconName(history) {
    if (history.EventType == 'TaskFailed') {
        return 'Warning';
    }
    else if (history.EventType == 'TaskCompleted' && history.FunctionName == 'TransferHarvestEmployeeTimesheetActivity') {
        return 'DateTime';
    }
    else if (history.EventType == 'TaskCompleted') {
        return 'Completed';
    }
    else if (history.EventType == 'ExecutionStarted') {
        return 'SyncStatus';
    }
    else if (history.EventType == 'ExecutionCompleted' && history.OrchestrationStatus == 'Failed') {
        return 'StatusErrorFull';
    }
    else if (history.EventType == 'ExecutionCompleted' && history.OrchestrationStatus == 'Completed') {
        return 'CompletedSolid';
    }
    else {
        return 'Info';
    }
}
function getHistoryEventText(history) {
    if (history.EventType == 'TaskCompleted' && history.FunctionName == 'TransferHarvestEmployeeTimesheetActivity') {
        return react_1.default.createElement(office_ui_fabric_react_1.Text, null,
            "Imported ",
            history.Result.entriesProcessed,
            " of ",
            history.Result.entriesFound,
            " for ",
            history.Result.harvestName);
    }
    else if (history.FunctionName) {
        return react_1.default.createElement(office_ui_fabric_react_1.Text, null, history.FunctionName);
    }
    else {
        return null;
    }
}
const ImportHistory = ({ importStatus }) => {
    return (react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontalAlign: "start", verticalAlign: "start", tokens: { childrenGap: 15 }, styles: { root: { marginBottom: '80px' } } },
        react_1.default.createElement(office_ui_fabric_react_1.Text, { block: true, variant: "large" }, "Import History"),
        importStatus.historyEvents.map(history => {
            return (react_1.default.createElement(office_ui_fabric_react_1.ActivityItem, { activityDescription: react_1.default.createElement(office_ui_fabric_react_1.Text, null, history.EventType), comments: getHistoryEventText(history), activityIcon: react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: getHistoryIconName(history) }), timeStamp: history.Timestamp }));
        })));
};
exports.default = ImportHistory;
